import i18n from 'src/i18n';

export const getRequiredField = () => i18n.t('app:errorsField.required');
export const getErrorMail = () => i18n.t('app:errorsField.email');
export const getErrorPhoto = () => i18n.t('app:errorsField.photo');

export const maxStringLength = (num: number) => i18n.t('app:errorsField.maxStringLength', { num });
export const minStringLength = (num: number) => i18n.t('app:errorsField.minStringLength', { num });
